/**
 * Get the window scroll left position
 *
 * @export
 * @returns {number} the current scroll left position
 */
export function getScrollLeft() {
	return window.scrollX || document.body.scrollLeft;
}

/**
 * Get the window scroll top position
 *
 * @export
 * @returns {number} the current scroll top position
 */
export function getScrollTop() {
	return window.scrollY || document.body.scrollTop;
}
